import { Input, KeyCode } from "../../../lib/Input";
import Ability from "../../Ability";
import Player from "../../Player";

export default class Cloak extends Ability {

    constructor(player: Player) {
        super(player, {
            cooldown: 20,
            duration: 4,
            energyCost: 25,
            icon: 6,
            trigger: KeyCode.Digit1,
            triggerType: Input.GetKeyDown,
            info: `Cloak (20s cooldown) - Turn invisible for 4 seconds`
        })
    }

    onDurationEnd(): void {
        this.player.isCloaked = false;
    }

    onUse(): void {
        this.player.isCloaked = true;
    }
}